import {IconButton, MenuItem, Popover} from '@mui/material';
import React, { FC, memo } from 'react';
import { Iconify } from 'src/UIKit/Iconify';
import { useUiContext } from 'src/UIProvider';

interface IProps {
    open: any;
    onClose: () => void;
    onAdd: () => void;
    onEdit: () => void;
}

export const SerialCategoryContextMenu: FC<IProps> = memo(({ onAdd, onEdit, open, onClose }) => {
    const { t } = useUiContext();

    const handleCloseMenu = () => {
        onClose();
    };

    const onHandleAdd = () => {
        onAdd();
    }

    const onHandleEdit = () => {
        onEdit();
    };

    return (
        <Popover
            open={Boolean(open)}
            anchorEl={open}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{ sx: { p: 1, width: 140, '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75, }, }, }}
        >
            <MenuItem onClick={onHandleAdd}>
                <Iconify icon="gala:add" sx={{ mr: 2 }} />{t("common.create")}
            </MenuItem>
            <MenuItem onClick={onHandleEdit}>
                <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />{t('common.edit')}
            </MenuItem>
        </Popover>
    );
})
